import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';


const RecipientsGroupsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/alerts/recipients-groups" */
    'routes/Alerts/RecipientsGroupsRoute'
  )
));

const UsageAlertsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/alerts/usage-alerts" */
    'routes/Alerts/UsageAlertsRoute'
  )
));

const EditUsageAlertsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/alerts/edit-usage-alerts" */
    'routes/Alerts/EditUsageAlertsRoute'
  )
));



const getAlertsRoutes = () => {
  return [
    {path: paths.getPathAlertRecipientsGroups(), component: RecipientsGroupsRoute},
    {path: paths.getPathUsageAlerts(), component: UsageAlertsRoute},
    {path: paths.getPathEditUsageAlerts(), component: EditUsageAlertsRoute},
  ]
}



export { getAlertsRoutes };
